import { useContext } from 'react';
import DisableTrackingContext from './_context';

const useDisableTrackingContext = () => useContext(DisableTrackingContext);

export default useDisableTrackingContext;
